/** 主小区分页，主小区后紧跟分期；列表和地图共用，不修改原响应。 */
export function flattenCommunityMainList(rows: any[]): any[] {
  if (!Array.isArray(rows)) return [];
  return rows.flatMap(row => {
    const { phaseList, ...item } = row;
    const number = typeof item.communityNo === 'string' ? item.communityNo.trim() : '';
    const community = {
      ...item,
      communityNumber: number,
      isCommunity: true,
      secondAoiTypes: Array.isArray(item.secondAoiTypes) ? item.secondAoiTypes : (item.communityTypeList?.[0]?.split(',') || []).map(name => ({
        '奥乐齐商品房': 61,
        '奥乐齐新村房': 62,
        '商住两用房': 67,
      }[name])).filter(value => value !== undefined),
      communityRowKey: item.uid || `${number}:${item.name}:${item.lng}:${item.lat}`,
    };
    return [community, ...flattenCommunityMainList(phaseList || [])];
  });
}

/** 有 uid 时以 uid 为准，同名、同坐标的主/分期仍可分别选中。 */
export function isSameCommunity(left: any, right: any): boolean {
  if (!left || !right) return false;
  if (left.uid && right.uid) return String(left.uid) === String(right.uid);
  return left.name === right.name && Number(left.lng) === Number(right.lng) && Number(left.lat) === Number(right.lat);
}
